import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { action } from 'mobx';
import { LocalDoctorService } from 'application/import/services';
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm } from 'application/facility-order-new-flow/forms';
import _ from "lodash";

class FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        super(rootStore, {
            name: 'facility-order-template-custom-ordering-doctor-change-modal',
            Form: FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm,
            authorization: 'portalSection.update',
            FormClass: FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm,
            autoInit: false
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplate = facilityOrderTemplate;
        this.localDoctorService = new LocalDoctorService(rootStore.application.baasic.apiClient);

        this.doctorStore = new BaasicDropdownStore({
            textField: 'orderingDoctor',
            filterable: true,
            returnObject: true,
        }, {
            fetchFunc: async (term) => {
                const response = await this.localDoctorService.find({ searchQuery: term, rpp: 20 });

                _.extend(response.data,
                    {
                        item: _.map(response.data.item, (item => {
                            return _.extend(
                                item, {
                                orderingDoctor: item.name + " - " + item.npi,
                            }
                            );
                        }))
                    }
                );

                return response.data.item;
            }
        });

        this.form.clear();
        this.form.$("customOrderingDoctorId").value = this.facilityOrderTemplate.customOrderingDoctorId;
    }

    @action.bound
    async createResource(resource) {
        this.facilityOrderTemplate.customOrderingDoctorId = resource.customOrderingDoctorId;
        this.modalParams.close();
    }
}
export default FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModalStore;
